import { useCallback, useMemo } from "react";
import { useSearch, useNavigate } from "@tanstack/react-router";
import type { AdminSearchParams } from "@/features/admin/types";
import type { SortField, SortDirection } from "./userUtils";

export function useUsersSearchParams() {
  const search = useSearch({
    from: "/admin",
  }) as AdminSearchParams;
  const navigate = useNavigate({ from: "/admin" });

  const sorting = useMemo(() => {
    const sortColumn = search.usersSortBy as SortField | undefined;
    const sortDirection = (search.usersSortDirection ?? "asc") as SortDirection;
    return {
      sortField: sortColumn ?? ("email" as SortField),
      sortDirection,
    };
  }, [search.usersSortBy, search.usersSortDirection]);

  const updateSearchParams = useCallback(
    (updates: { sortField?: SortField; sortDirection?: SortDirection }) => {
      const newSearch: AdminSearchParams = { ...search };

      if (updates.sortField === undefined) {
        delete newSearch.usersSortBy;
        delete newSearch.usersSortDirection;
      } else {
        newSearch.usersSortBy = updates.sortField;
        newSearch.usersSortDirection = (updates.sortDirection ?? "asc") as "asc" | "desc";
      }

      navigate({
        search: newSearch,
        replace: true,
      });
    },
    [search, navigate]
  );

  return {
    sorting,
    updateSearchParams,
  };
}
